export const japaneseDomainMessages = {
    notification: {
        saved: "保存しました",
        error: "エラーが発生しました",
    }
}
